<template>
  <b-modal
    id="profile-pic-input"
    ref="profile-pic-input"
    centered
    title="Change Profile Picture"
    @hide="resetData"
    class="overflow-hidden"
  >
    <div class="modal-wrap">
      <div class="wrapper mb-3 text-center">
        <img
          style="width:100px;height:100px;border-radius:50%"
          :src="userObj.photourl"
          id="user-logo"
        />
      </div>
      <b-form>
        <b-form-group :invalid-feedback="formErrors.photo" :state="fieldState.photo">
          <b-form-file
            required
            v-model="form.photo"
            accept=".jpg, .jpeg, .png, .gif"
            id="photo"
            :state="fieldState.photo"
            placeholder="Choose a file or drop it here..."
            drop-placeholder="Drop file here..."
          ></b-form-file>
        </b-form-group>
      </b-form>
    </div>
    <template v-slot:modal-footer="{ ok, cancel }">
      <b-button variant="light" @click="cancel()">Cancel</b-button>
      <StatefulButton
        :error="error"
        :loading="submitting"
        loadingText="Saving..."
        text="Save"
        variant="primary"
        @click="submit"
      />
    </template>
    <div
      class="overlay-load position-absolute w-100 h-100 d-flex align-items-center justify-content-center"
      style="top:0;left:0;z-index:10;background-color:rgba(255,255,255,0.7)"
      v-if="submitting"
    >
      <b-spinner label="Small Spinner"></b-spinner>
    </div>
  </b-modal>
</template>

<script>
import { mapState } from "vuex";
import { validateRequired, checkFormErrors } from "@/utils/validators";
import { UserService } from "@/services";
import StatefulButton from "@/components/actions/StatefulButton";

export default {
  data() {
    return {
      form: { photo: null },
      formErrors: {},
      error: false,
      submitting: false
    };
  },
  components: {
    StatefulButton
  },
  computed: {
    ...mapState(["userObj"]),
    fieldState() {
      return checkFormErrors(this.formErrors);
    }
  },
  methods: {
    validateForm() {
      const { photo } = this.form;
      let { errors, valid } = validateRequired(this.form);

      if (
        !errors.photo &&
        !["image/jpeg", "image/jpg", "image/png"].includes(photo.type)
      ) {
        errors.photo = "Only picture is allowed i.e jpeg, jpg, png";
        valid = false;
      }

      if (!errors.photo && photo.size > 2 * 1024 * 1024) {
        errors.photo = "File size is too large (2MB Maximum)";
        valid = false;
      }

      if (valid === false) throw errors;
    },

    async submit(event) {
      event.preventDefault();
      this.submitting = true;

      try {
        this.validateForm();
        const { photourl } = await UserService.changeProfilePicture(
          this.form.photo
        );

        this.$store.dispatch("user/updateProfile", { photourl });
        this.$bvModal.hide("profile-pic-input");
        this.$store.dispatch("toast", {
          message: "We've updated your profile picture"
        });
      } catch (err) {
        this.error = true;
        this.formErrors = err;
      } finally {
        this.submitting = false;
      }
    },
    resetData() {
      Object.assign(this.$data, this.$options.data.apply(this));
    }
  }
};
</script>

<style></style>
